/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TerminalActionStatus = {
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    CANCEL_REQUESTED: 'CANCEL_REQUESTED',
    CANCELED: 'CANCELED',
    COMPLETED: 'COMPLETED'
} as const;
export type TerminalActionStatus = typeof TerminalActionStatus[keyof typeof TerminalActionStatus];

